import { useIntl } from 'react-intl'
import {CrudProvider} from '../../../../../services/loggedin/CrudContext'
import {ListComponent} from '../../../../parts/crud/List'
import { ColumnType } from '../../../../parts/crud/Types'

export const ServerGroupList = () => {
  const intl = useIntl()
  const columns: Array<ColumnType> = [
      
      {
        title: intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVER_GROUP.SERVER_GROUP_NAME'}),
        key: 'group_name',
        type: 'text',
        orderable: true
      },
      {
        title: intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVER_GROUP.SERVER_GROUP_DESCRIPTION'}),
        key: 'group_description',
        type: 'text',
        orderable: true
      },
  ];
  return (
    <>
      <CrudProvider api='system-settings/server-groups'>
        <ListComponent columns={columns}

          defOrder='group_name'
          defOrderDir='asc'
          title_delete={intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVER_GROUP.DELETE'})}
          text_eliminare={intl.formatMessage({
            id: 'SYSTEM_SETTINGS.SERVER_GROUP.SURE_DELETE',
          })}
          text_eliminato={intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVER_GROUP.DELETED'})}
          text_nuovo={intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVER_GROUP.ADD'})}
        />
      </CrudProvider>
    </>
  )
}